import { StandardSvgProps } from "src/components/svg/StandardSvgProps";
import { SDefaultSvg } from 'src/components/svg/SvgStyles';
import styled from "src/lib/styles/css";
//#region [Props]
type FilmQuizCheckCorrectAnswerSvgProps = {
} & StandardSvgProps;
//#endregion

//#region [Component]
export default function FilmQuizCheckCorrectAnswerSvg({ className }: FilmQuizCheckCorrectAnswerSvgProps) {
	return (
		<SDefaultSvg className={className} xmlns="http://www.w3.org/2000/svg" width="25.216" height="18.427" viewBox="0 0 25.216 18.427">
			<g transform="translate(-59.308 -1172.479)">
				<SCheckCorrectAnswer width="5.486" height="15.088" rx="2.743" transform="translate(59.308 1180.238) rotate(-45)" />
				<rect width="5.486" height="20.574" rx="2.743" transform="translate(80.645 1172.479) rotate(45)" />
			</g>
		</SDefaultSvg>
	);
}
//#endregion

//#region [Styles]
const SCheckCorrectAnswer = styled.rect`
	fill:#231a41;
`
//#endregion